import React, { useState } from 'react';
import PropTypes from 'prop-types';

const ClaimContext = React.createContext({});
export function ClaimProvider({ children }) {
  const [formState, setFormState] = useState({});
  const [claimRequest, setClaimRequest] = useState({});
  const [claimReview, setClaimReview] = useState({});

  const handleResetFormState = () => {
    setFormState({});
    setClaimRequest({});
    setClaimReview({});
  }

  /**
   * @param {object} updatedFormState 
   */
  const handleUpdateFormState = (updatedFormState) => {
    setFormState((currentState) => ({
      ...currentState,
      ...updatedFormState
    }));
  }

  /**
   * @param {object} updatedClaimRequest 
   */
  const handleUpdateClaimRequest = (updatedClaimRequest) => {
    setClaimRequest((currentState) => ({
      ...currentState,
      ...updatedClaimRequest
    }));
  }

  /**
   * Replaces the entire claimRequest instead of merging.
   * Use this when the set of coverages may have changed (e.g. features removed).
   * @param {object} newClaimRequest 
   */
  const handleReplaceClaimRequest = (newClaimRequest) => {
    setClaimRequest(newClaimRequest);
  }

  /**
   * @param {object} updatedClaimReview
   */
  const handleUpdateClaimReview = (updatedClaimReview) => {
    setClaimReview((currentState) => ({
      ...currentState,
      ...updatedClaimReview
    }));
  }

  const context = {
    formState,
    claimRequest,
    claimReview,
    updateFormState: handleUpdateFormState,
    updateClaimReview: handleUpdateClaimReview,
    updateClaimRequest: handleUpdateClaimRequest,
    replaceClaimRequest: handleReplaceClaimRequest,
    resetFormState: handleResetFormState
  };

  return (
    <ClaimContext.Provider value={context}>
      {children}
    </ClaimContext.Provider>
  )
}

ClaimProvider.propTypes = {
  children: PropTypes.elementType
};

export default ClaimContext;
